import * as React from "react"
import { cn } from "../../lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return <textarea ref={ref} className={cn("ui-textarea", className)} {...props} />
})

Textarea.displayName = "Textarea"

export { Textarea }
